import { ROUTES } from 'theSource/app/routes';

export const getQuickLinkItems = (medicalBenefitLookupCode?: string) => [
  {
    name: 'pages.benefits:viewMyContacts',
    path: ROUTES.additional.profile.contacts.path,
  },
  {
    name: 'pages.benefits:viewMyMedicalBenefits',
    path: `${ROUTES.additional.benefits.myBenefits.path}${
      medicalBenefitLookupCode ? `/${medicalBenefitLookupCode}` : ''
    }`,
  },
  {
    name: 'pages.benefits:accessMyIdCards',
    path: ROUTES.main.idCards.path,
  },
];
